import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExportVersionPreview } from '../../pages/course-export/CourseExportVersionPreview';
import { courseExportVersionPreviewParamsSchema } from '../../routing/schemas';
import { getVersionPreviewUrlQueryOptions } from '../../pages/course-export/components/CourseExportDetail.queries';

// Under _private but not _home: the preview fills the whole tab, without the side menu.
export const Route = createFileRoute('/_private/course-exports/$course_version_guid/versions/$version_guid/preview')({
  params: {
    parse: (rawParams) => courseExportVersionPreviewParamsSchema.parse(rawParams),
    stringify: (params) => params,
  },
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(
      getVersionPreviewUrlQueryOptions(context.apiClient, params.course_version_guid, params.version_guid)
    );
  },
  component: CourseExportVersionPreviewRoute,
});

function CourseExportVersionPreviewRoute() {
  const { apiClient } = Route.useRouteContext();
  return <CourseExportVersionPreview portalApiClient={apiClient} />;
}
